import styled from "styled-components";

import { CompanyProfileButton } from "./CompanyProfileButton";

import { Text } from "@otta/design";
import { Company } from "@otta/search/schema";
import { pxToRem } from "@otta/design-tokens";
import { CompanyImage } from "@otta/search/pages/Messaging/InboxCard";
import { addPossessiveSuffix } from "@otta/search/utils/strings";

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${pxToRem(16)};
`;

const Description = styled(Text)`
  margin: ${pxToRem(8)} 0 ${pxToRem(16)};
`;

interface CompanyProfileCardProps {
  company: Pick<
    Company.Fragment,
    "name" | "urlSafeName" | "faviconPath" | "primaryColour"
  >;
}

export function CompanyProfileCard({
  company: { name, urlSafeName, faviconPath, primaryColour },
}: CompanyProfileCardProps) {
  return (
    <Wrapper>
      <div>
        <Text bold size={1}>
          Want to learn more about {name}?
        </Text>
        <Description>
          View {addPossessiveSuffix(name)} mission, values, funding and more on
          their company profile.
        </Description>

        <CompanyProfileButton
          company={{ name, urlSafeName }}
          section="learn-more-about-company"
          level="secondary"
        />
      </div>

      <CompanyImage
        image={faviconPath}
        name={name}
        primaryColour={primaryColour}
      />
    </Wrapper>
  );
}
